import handlebars from "handlebars";

handlebars.registerHelper("increment", function (value) {
    return parseInt(value) + 1;
});

handlebars.registerHelper("for", function (from, to, incr, block) {
    var accum = "";
    for (var i = from; i < to; i += incr) accum += block.fn(i);
    return accum;
});

handlebars.registerHelper("ifCond", function (v1, v2, options) {
    if (v1 === v2) {
        return options.fn(this);
    }
    return options.inverse(this);
});

handlebars.registerHelper("eq", function (v1, v2) {
    return v1 === v2;
});

handlebars.registerHelper("defined", function (value) {
    return value !== null && value !== undefined;
});

/**
 * Returns "active" or "not-active" based on whether active_challenge has content.
 * Treats empty array as not active. Used to avoid {{#if}} inside class attribute.
 */
handlebars.registerHelper("activeChallengeClass", function (activeChallenge) {
    const hasContent =
        activeChallenge != null &&
        (!Array.isArray(activeChallenge) || activeChallenge.length > 0);
    return hasContent ? "active" : "not-active";
});

handlebars.registerHelper("storeLevelClass", function (status) {
    return status === "open" ? "" : "is-locked";
});

handlebars.registerHelper("extraPurchasedClass", function (purchased) {
    return purchased ? "is-purchased" : "";
});

handlebars.registerHelper("extrasTypeClass", function (type) {
    let typeClass = "";

    switch (type) {
        case "race":
            typeClass = "is-race";
            break;
        case "quiz":
            typeClass = "is-quiz";
            break;
        case "question":
            typeClass = "is-questions";
            break;
        default:
            typeClass = "";
            break;
    }

    return typeClass;
});

handlebars.registerHelper("toUpper", function (value) {
    return value.toUpperCase();
});

handlebars.registerHelper("progressBarWidth", function (percentage) {
    const pct = isNaN(Number(percentage))
        ? 0
        : Math.max(0, Math.min(100, Number(percentage)));
    return `style="width: ${pct}%"`;
});

/** Weekly person ring: 0% when no progress_detail; else clamp percentage like progressBarWidth. */
handlebars.registerHelper(
    "progressConicStyle",
    function (progressDetail, percentage) {
        const raw = progressDetail ? percentage : 0;
        const pct = isNaN(Number(raw))
            ? 0
            : Math.max(0, Math.min(100, Number(raw)));
        return `style="background:conic-gradient(#e74839 ${pct}%, transparent 0);"`;
    },
);

/**
 * Splits a string on whitespace and wraps each segment in <span>.
 * Example: "Visit Store" → <span>Visit</span><span>Store</span>
 */
handlebars.registerHelper("wordsAsSpans", function (text) {
    if (text == null || text === "") {
        return "";
    }
    const parts = String(text)
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    if (!parts.length) {
        return "";
    }
    const html = parts
        .map(
            (word) =>
                `<span>${handlebars.escapeExpression(word)}</span>`,
        )
        .join("");
    return new handlebars.SafeString(html);
});

handlebars.registerHelper("gradientStyle", function (gradient) {
    if (
        !gradient ||
        gradient.color_start == null ||
        gradient.color_end == null
    ) {
        return "";
    }
    const deg = Number(gradient.degree);
    const angle = Number.isFinite(deg) ? deg : 90;
    const css = `style="background: linear-gradient(${angle}deg, ${gradient.color_start}, ${gradient.color_end})"`;
    return new handlebars.SafeString(css);
});

handlebars.registerHelper(
    "replacePlaceholder",
    function (text, placeholder, value) {
        if (typeof text !== "string") return text;

        const escaped = placeholder.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const regex = new RegExp(escaped, "g");

        return text.replace(regex, value);
    },
);

const compile = (htmlTemplate, data) => {
    const template = handlebars.compile(htmlTemplate);
    return template(data);
};

export default compile;
